let filtreDate = {
    props: {
        params: Object,
    },
    directives: {
        // clickaway
    },
    data() {
        return {
            isDropdownActive: false,
        }
    },
    computed: {
        currentDate: function() {
            return new Date().toJSON().slice(0, 10);
        }
    },
    methods: {
        datevent() {
            this.$root.callfilters(event)
        },
    },
    // methods: {
    //     filtrevent () {
    //         this.$emit('filtrevent')
    //     }
    // },
    template: `
    <div class="profile filter-block">
        <div class="fieldDate">
            <div>
                <label for="dateDebut">du</label>
                <input @change="datevent" type="date" class="datepicker dateDebut" name="dd" :min="currentDate" :max="params.dateFin" v-model="params.dateDebut">
            </div>
            <div>
                <label for="dateFin">au</label>
                <input @change="datevent" type="date" class="datepicker dateFin" name="df" :min="params.dateDebut" v-model="params.dateFin">
            </div>
        </div>
    </div>
    `
};